module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-geo-puzzle.6b9a5886.jpg";